import { defineStyleConfig } from '@chakra-ui/react';

import { defaultTransition } from 'utils/themeConstants';

// TODO rename variants
const secondary = {
  bgColor: 'white.10',
  color: 'white.80',
  ':hover, :focus': {
    bgColor: 'white.20',
    _disabled: {
      bgColor: 'white.10',
    },
  },
};

export const buttonTheme = defineStyleConfig({
  baseStyle: {
    borderRadius: '4px',
    fontFamily: 'heading',
    color: 'white.100',
    fontWeight: 'normal',
    textTransform: 'uppercase',
    transition: `${defaultTransition}, width 0s`,
    _disabled: {
      opacity: 0.6,
    },
  },
  variants: {
    primary: {
      bgColor: 'bloodMoon.100',
      ':hover, :focus': {
        bgColor: 'fieryCoral.100',
        _disabled: {
          bgColor: 'bloodMoon.100',
        },
      },
    },
    'primary-link': {
      bgColor: 'transparent',
      color: 'fieryCoral.100',
      p: 0,
      textDecoration: 'underline',
      fontFamily: 'body',
      ':hover, :focus': {
        color: 'fieryCoral.80',
        _disabled: {
          opacity: 0.6,
        },
      },
    },
    ghost: {
      bgColor: 'transparent',
      color: 'white.100',
      opacity: 0.8,
      border: 'none',
      borderColor: 'none',
      ':hover, :focus': {
        opacity: 1,
        bgColor: 'transparent',
        color: 'white.100',
        _disabled: {
          bgColor: 'transparent',
        },
      },
    },
    'primary-ghost': {
      bgColor: 'bloodMoon.40',
      border: '1px solid',
      borderColor: 'fieryCoral.100',
      ':hover, :focus': {
        bgColor: 'fieryCoral.100',
        _disabled: {
          bgColor: 'bloodMoon.40',
        },
      },
    },
    secondary,
    'secondary-outlined': {
      ...secondary,
      border: '1px solid',
      borderColor: 'white.40',
    },
    'secondary-gradient': {
      background:
        'linear-gradient(225deg, rgba(240, 240, 240, 0.2) 0%, rgba(197, 197, 197, 0.2) 18%, rgba(176, 176, 176, 0.2) 73%, rgba(126, 126, 126, 0.2) 100%)',
      ':hover, :focus': {
        background:
          'linear-gradient(225deg, rgba(240, 240, 240, 0.4) 0%, rgba(197, 197, 197, 0.4) 18%, rgba(176, 176, 176, 0.4) 73%, rgba(126, 126, 126, 0.4) 100%)',
      },
      _disabled: {
        background:
          'linear-gradient(225deg, rgba(240, 240, 240, 0.2) 0%, rgba(197, 197, 197, 0.2) 18%, rgba(176, 176, 176, 0.2) 73%, rgba(126, 126, 126, 0.2) 100%)',
      },
      position: 'relative',
      _before: {
        content: '""',
        position: 'absolute',
        inset: 0,
        background:
          'linear-gradient(360deg, rgba(240, 240, 240, 0.6) 0%, rgba(240, 240, 240, 0.24) 100%)',
        padding: '2px',
        borderRadius: '4px',
        mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
        maskComposite: 'exclude',
      },
    },
    tertiary: {
      background:
        'linear-gradient(225deg, rgba(109, 241, 229, 0.8) 0%, rgba(79, 197, 186, 0.8) 18%, rgba(38, 166, 154, 0.8) 73%, rgba(26, 116, 107, 0.8) 100%)',
      ':hover, :focus': {
        background:
          'linear-gradient(225deg, rgba(109, 241, 229, 0.9) 0%, rgba(79, 197, 186, 0.9) 18%, rgba(38, 166, 154, 0.9) 73%, rgba(26, 116, 107, 0.9) 100%)',
        _disabled: {
          background:
            'linear-gradient(225deg, rgba(109, 241, 229, 0.8) 0%, rgba(79, 197, 186, 0.8) 18%, rgba(38, 166, 154, 0.8) 73%, rgba(26, 116, 107, 0.8) 100%)',
        },
      },
      position: 'relative',
      _before: {
        content: '""',
        position: 'absolute',
        inset: 0,
        background:
          'linear-gradient(360deg, rgba(76, 194, 183, 0.6) 0%, rgba(76, 194, 183, 0.24) 100%)',
        padding: '2px',
        borderRadius: '4px',
        mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
        maskComposite: 'exclude',
      },
    },
    'tertiary-gradient': {
      color: 'white.80',
      background:
        'linear-gradient(225deg, rgba(109, 241, 229, 0.8) 0%, rgba(79, 197, 186, 0.8) 18%, rgba(38, 166, 154, 0.8) 73%, rgba(26, 116, 107, 0.8) 100%)',
      ':hover, :focus': {
        background:
          'linear-gradient(225deg, rgba(109, 241, 229, 0.9) 0%, rgba(79, 197, 186, 0.9) 18%, rgba(38, 166, 154, 0.9) 73%, rgba(26, 116, 107, 0.9) 100%)',
        _disabled: {
          background:
            'linear-gradient(225deg, rgba(109, 241, 229, 0.8) 0%, rgba(79, 197, 186, 0.8) 18%, rgba(38, 166, 154, 0.8) 73%, rgba(26, 116, 107, 0.8) 100%)',
        },
      },
      position: 'relative',
      _before: {
        content: '""',
        position: 'absolute',
        inset: 0,
        background:
          'linear-gradient(360deg, rgba(76, 194, 183, 0.6) 0%, rgba(76, 194, 183, 0.24) 100%)',
        padding: '2px',
        borderRadius: '4px',
        mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
        maskComposite: 'exclude',
      },
    },
    icon: {
      bgColor: 'eerieBlack.100',
      text: 'white.80',
      _hover: {
        bgColor: 'jet.100',
      },
    },
    'garage-header': {
      bgColor: 'white.10',
      borderRadius: 'full',
      ':hover, :focus': {
        bgColor: 'white.40',
        _disabled: {
          bgColor: 'white.40',
        },
      },
    },
    'guide-button': {
      bgColor: 'white.80',
      color: 'eerieBlack.100',
      rounded: '0.25rem',
      ':hover, :focus': {
        bgColor: 'white.100',
        _disabled: {
          bgColor: 'white.80',
          opacity: 0.6,
        },
      },
    },
    'my-car-button': {
      background:
        'linear-gradient(225deg, #6DF1E5 0%, #4FC5BA 18%, #26A69A 73%, #1A746B 100%)',
      backgroundClip: 'text',
      border: '2px solid',
      borderColor: 'rgba(76, 194, 183, 0.2)',
      cursor: 'pointer',
      backgroundOrigin: 'border-box',
      _hover: {
        opacity: 0.9,
        borderColor: 'rgba(76, 194, 183, 0.6)',
      },
      _active: {
        background:
          'linear-gradient(225deg, #6DF1E5 0%, #4FC5BA 18%, #26A69A 73%, #1A746B 100%)',
        color: 'black.80',
        borderColor: 'transparent',
      },
      _disabled: {
        opacity: 0.4,
        _hover: {
          color: '#6DF1E5',
          opacity: 0.5,
        },
      },
      '[data-active]': {
        background:
          'linear-gradient(225deg, #6DF1E5 0%, #4FC5BA 18%, #26A69A 73%, #1A746B 100%)',
        color: 'black.80',
        opacity: 1,
        borderColor: 'transparent',
      },
    },
    goldenButton: {
      background:
        'linear-gradient(225deg, rgba(252, 244, 191, 0.8) 0%, rgba(239, 200, 98, 0.8) 18%, rgba(205, 152, 50, 0.8) 73%, rgba(187, 129, 27, 0.8) 100%)',
      color: 'white.100',
      zIndex: 100,
      ':hover, :focus': {
        background:
          'linear-gradient(225deg, rgba(252, 244, 191, 0.9) 0%, rgba(239, 200, 98, 0.9) 18%, rgba(205, 152, 50, 0.9) 73%, rgba(187, 129, 27, 0.9) 100%)',
      },
    },
    'upgrade-button': {
      background:
        'linear-gradient(225deg, rgba(109, 241, 229, 0.2) 0%, rgba(79, 197, 186, 0.2) 18%, rgba(38, 166, 154, 0.2) 73%, rgba(26, 116, 107, 0.2) 100%)',
      _hover: {
        background:
          'linear-gradient(225deg, rgba(109, 241, 229, 0.4) 0%, rgba(79, 197, 186, 0.4) 18%, rgba(38, 166, 154, 0.4) 73%, rgba(26, 116, 107, 0.4) 100%)',
      },
      transition: 'background 0.2s ease-in-out',
      position: 'relative',
      alignItems: 'center',
      justifyContent: 'center',
      p: '2',
      gap: '2',
      w: 'full',
      borderRadius: '4px',
      _before: {
        content: '""',
        position: 'absolute',
        inset: 0,
        borderRadius: '4px',
        padding: '2px',
        background:
          'linear-gradient(360deg, rgba(76, 194, 183, 0.6) 0%, rgba(76, 194, 183, 0.24) 100%)',
        mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
        maskComposite: 'exclude',
      },
    },
    mainTab: {
      bg: 'linear-gradient(360deg, rgba(165, 165, 165, 0.1) 0%, rgba(165, 165, 165, 0.04) 100%)',
      borderBottom: '2px solid',
      borderColor: 'rgba(255, 255, 255, 0.18)',
      opacity: 0.9,
      fontWeight: 400,
      color: 'white.40',
      textTransform: 'uppercase',
      borderRadius: '0px',
      borderTopRadius: '4px',
      _hover: {
        bg: 'linear-gradient(360deg, rgba(165, 165, 165, 0.2) 0%, rgba(165, 165, 165, 0.08) 100%)',
        borderBottom: '2px solid',
        borderColor: 'rgba(255, 255, 255, 0.3)',
        color: 'white.80',
        opacity: 1,
      },
      _active: {
        bg: 'linear-gradient(360deg, rgba(79, 197, 186, 0.4) 0%, rgba(79, 197, 186, 0.16) 100%)',
        borderBottom: '2px solid',
        borderColor: 'rgba(79, 197, 186, 1)',
        color: 'treasuredTeal.100',
        opacity: 1,
      },
    },
    subTab: {
      position: 'relative',
      _before: {
        content: '""',
        position: 'absolute',
        inset: 0,
        borderRadius: '4px',
        padding: '2px',
        background:
          'linear-gradient(360deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.08) 100%)',
        mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
        maskComposite: 'exclude',
      },
      borderRadius: '4px',
      px: { base: 2, md: 3 },
      h: '34px',
      opacity: 1,
      color: 'white.80',
      fontWeight: 400,
      fontSize: '12.5px',
      lineHeight: '1rem',
      _hover: {
        _before: {
          background:
            'linear-gradient(360deg, rgba(255, 255, 255, 0.40) 0%, rgba(255, 255, 255, 0.20) 100%)',
        },
        opacity: 1,
      },
      _active: {
        background:
          'linear-gradient(225deg, #FFFFFF 0%, #EEEEEE 18%, #A0A0A0 73%, #979797 100%)',
        color: 'black.80',
        border: 'none',
        opacity: 1,
      },
    },
    blueButton: {
      background:
        'linear-gradient(225deg, rgba(109, 177, 241, 0.2) 0%, rgba(79, 138, 197, 0.2) 18%, rgba(38, 102, 166, 0.2) 73%, rgba(26, 59, 116, 0.2) 100%)',
      color: 'rgba(109, 177, 241, 0.8)',
      _hover: {
        background:
          'linear-gradient(225deg, rgba(109, 177, 241, 0.4) 0%, rgba(79, 138, 197, 0.4) 18%, rgba(38, 102, 166, 0.4) 73%, rgba(26, 59, 116, 0.4) 100%)',
      },
      cursor: 'pointer',
      backgroundOrigin: 'border-box',
      position: 'relative',
      _before: {
        content: '""',
        position: 'absolute',
        inset: 0,
        borderRadius: '4px',
        padding: '2px',
        background:
          'linear-gradient(360deg, rgba(42, 102, 255, 0.6) 0%, rgba(42, 102, 255, 0.24) 100%)',
        mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
        maskComposite: 'exclude',
      },
    },
    crossmint: {
      background: 'rgba(26, 116, 107, 1)',
      color: 'rgba(255, 255, 255, 0.8)',
      _hover: {
        background: 'rgba(79, 197, 186, 1)',
        color: 'rgba(255, 255, 255, 1)',
      },
      disabled: {
        background: 'rgba(38, 166, 154, 0.5)',
        color: 'rgba(255, 255, 255, 0.5)',
      },
    },
    redButton: {
      background:
        'linear-gradient(225deg, rgba(255, 0, 17, 0.2) 0%, rgba(216, 56, 50, 0.2) 18%, rgba(173, 53, 41, 0.2) 73%, rgba(139, 42, 33, 0.2) 100%)',
      color: 'rgba(255, 0, 17, 0.8)',
      _hover: {
        background:
          'linear-gradient(225deg, rgba(255, 0, 17, 0.4) 0%, rgba(216, 56, 50, 0.4) 18%, rgba(173, 53, 41, 0.4) 73%, rgba(139, 42, 33, 0.4) 100%)',
      },
      cursor: 'pointer',
      backgroundOrigin: 'border-box',
      position: 'relative',
      _before: {
        content: '""',
        position: 'absolute',
        inset: 0,
        borderRadius: '4px',
        padding: '2px',
        background:
          'linear-gradient(360deg, rgba(255, 53, 57, 0.6) 0%, rgba(255, 53, 57, 0.24) 100%)',
        mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
        maskComposite: 'exclude',
      },
    },
  },
  // sizes: {
  //   sm: {
  //     fontSize: '14px',
  //     lineHeight: '20px',
  //     paddingLeft: '8px',
  //     paddingRight: '8px',
  //     paddingTop: '4px',
  //     paddingBottom: '4px',
  //     height: 'auto',
  //   },
  //   md: {
  //     fontSize: '14px',
  //     lineHeight: '20px',
  //     paddingLeft: '12px',
  //     paddingRight: '12px',
  //     paddingTop: '7px',
  //     paddingBottom: '7px',
  //     height: 'auto',
  //   },
  //   lg: {
  //     fontSize: '16px',
  //     lineHeight: '16px',
  //     paddingLeft: '20px',
  //     paddingRight: '20px',
  //     paddingTop: '13px',
  //     paddingBottom: '13px',
  //     height: 'auto',
  //   },
  // },
  defaultProps: {
    variant: 'primary',
    size: 'md',
  },
});
